import React,{useState } from 'react';
import Icons from "../../Icons/Icons";
import {TopAddShortCut,Topnav,TopSearch} from '../HeaderInc';
 

const HeaderLogo = props => {

	const [isShowModal,setShowModal] = useState(false);
	const addClassMenu = (event) => {
	  document.body.classList.add('nav_open');
	  setShowModal(true);
	}
	const [isSearchVisible,setSearchVisible] = useState(false);
	const removeClassMenu = (event) => {
	  document.body.classList.remove('nav_open');
	  setShowModal(false); 
	}

	let 
		clickHandler = {onClick:(e)=>addClassMenu(e)}
			if(isShowModal===true){
		clickHandler = {onClick:(e)=>removeClassMenu(e)}
}

	const [isShowtopbar,setShowtopbar] = useState(false);
	const addClasstopbar = (event) => {
	  document.body.classList.add('topbar_open');
	  setShowtopbar(true);
	}
	const removeClasstopbar = (event) => {
	  document.body.classList.remove('topbar_open');
	  setShowtopbar(false); 
	}

	let 
		clickHandler1 = {onClick:(e)=>addClasstopbar(e)}
			if(isShowtopbar===true){
		clickHandler1 = {onClick:(e)=>removeClasstopbar(e)}

	}

 
	const logout = () => {
		props.onAuthenticateHandler();
		props.history.push("/login");
	}
	return (
		<>
		<div className="logo-header">
		 	{(window.location.hostname==='apps.myship.ca') && 
		 	<a href="#" className="logo">
			 	<img src="../../../../../assets/img/logo.png" alt="Logo" class="navbar-brand" />
			</a>
			}
			 
			<button {...clickHandler}  className="navbar-toggler sidenav-toggler ml-auto 1 mr-3" type="button" data-toggle="collapse" data-target="collapse" aria-expanded="false" aria-label="Toggle navigation">
				<span className="navbar-toggler-icon">
					<svg viewBox="0 0 24 24" width="32" height="32">
					 	<rect width="32" height="32" opacity="0" transform="rotate(180 12 12)"/>
					 	<circle cx="4" cy="12" r="1" fill='#fff'/>
					 	<rect width="14" height="2" x="7" y="11" rx=".94" ry=".94" fill='#fff'/>
					 	<rect width="18" height="2" x="3" y="16" rx=".94" ry=".94" fill='#fff'/>
					 	<rect width="18" height="2" x="3" y="6" rx=".94" ry=".94" fill='#fff'/> 
					</svg>
				</span>
			</button>
			<nav className="navbar_MobileView navbar navbar-header navbar-expand-lg d-lg-none">
				{
					props.isMobileView === true?
					<Topnav 
					leftMenuGenerate={props.leftMenuGenerate} 
					isMobileView={props.isMobileView}
					changeModuleHandler={props.changeModuleHandler}/>
					:
					<></>
				}
				
					<div> </div>
 					<ul className="navbar-nav topbar-nav"> 
 						<li className="nav-item focus toggle-nav-search hidden-caret m-0" >
							<a style={{"color":"#a1a5b7"}} className={(isSearchVisible===true)?"nav-link collapsed":"nav-link"} onClick={()=>setSearchVisible(true)} data-toggle="collapse" href="#search-nav" role="button" aria-expanded="false" aria-controls="search-nav">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="#a1a5b7">
                                    <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="#a1a5b7"></rect>
                                    <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="#a1a5b7"></path>
                                </svg>
							</a>
						</li>

 						<li className="nav-item focus dropdown hidden-caret svgIconFill m-0" >
                            <a className="nav-link cursor-pointer" data-toggle="dropdown" aria-expanded="false">                                
                                <Icons iconType="IconPlus" size={24} color={'#f44336'}/>                                
                            </a>
                            <TopAddShortCut windowData={props.windowData}/>
                        </li>
                        <li className="nav-item svgIconFill m-0" >
                        	<a className="nav-link cursor-pointer" onClick={logout}>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28">
									<path fill="#a1a5b7" d="M12.59,13l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76,1,1,0,0,0-.21-.33l-4-4a1,1,0,1,0-1.42,1.42L12.59,11H3a1,1,0,0,0,0,2ZM12,2A10,10,0,0,0,3,7.55a1,1,0,0,0,1.8.9A8,8,0,1,1,12,20a7.93,7.93,0,0,1-7.16-4.45,1,1,0,0,0-1.8.9A10,10,0,1,0,12,2Z"/>
								</svg>
                        	</a>
                        </li>
                    </ul>
				
			</nav>

			
		</div>
		<TopSearch 
			{...props} 
			isMobileView={true}
			setSearchVisible={setSearchVisible}
			isSearchVisible={isSearchVisible} />
		</>
	);
}

export default HeaderLogo;